import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Funcionário',
    path: '/pessoal/funcionario',
    name: 'funcionario',
    component: () => import('@/views/pessoal/funcionario/cadastro/Index.vue'),
    meta: {
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Funcionário',
    path: '/pessoal/funcionario/cadastro/:id?',
    parent: 'funcionario',
    name: 'cadastrofuncionario',
    component: () => import('@/views/pessoal/funcionario/cadastro/InclusaoEdicao.vue'),
    meta: {
      permissions: [
      ],
    },
  }, {
    description: 'Edição de Funcionário',
    path: '/pessoal/funcionario/editar/:id',
    parent: 'funcionario',
    name: 'editarfuncionario',
    component: () => import('@/views/pessoal/funcionario/cadastro/InclusaoEdicao.vue'),
    meta: {
      permissions: [
      ],
    },
  },
]
